import axios from "axios";

export default class {
	static getAll = async data => {
		let result = {
			data: null,
			error: null
		};
		await axios
			.post(`${process.env.REACT_APP_API_URL}/qa/all`, data)
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};
}
